function createShallowSetState(setter) {
  return (next) => setter((prev) => mergeIfNotShallowEqual(prev, next));
}
function mergeIfNotShallowEqual(prev, next) {
  for (const key in next)
    if (prev[key] !== next[key])
      return { ...prev, ...next };
  return prev;
}
export {
  createShallowSetState,
  mergeIfNotShallowEqual
};
